import { FC, useState } from 'react'
import { Button, Dropdown, NavLink } from 'react-bootstrap'
import fullLogoLight from '../../../client/logo/logo-full-light.svg'
import { Dialog } from 'primereact/dialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

interface AboutProps {
    triggerType?: 'a' | 'button' | 'dropdownItem'
    text?: string
}

const About: FC<AboutProps> = ({ triggerType = '', text }) => {
    const [show, setShow] = useState(false)

    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)

    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <FontAwesomeIcon icon={faInfoCircle} className="me-1" /> About
        </div>
    )

    const footerContent = (
        <div className="text-center border-top pt-3">
            <Button variant="outline-secondary" onClick={handleClose}>
                Close
            </Button>
        </div>
    )

    return (
        <>
            {(() => {
                switch (triggerType) {
                    case 'a':
                        return (
                            <NavLink onClick={handleShow}>
                                <FontAwesomeIcon icon={faInfoCircle} />
                            </NavLink>
                        )
                    case 'dropdownItem':
                        return (
                            <Dropdown.Item onClick={handleShow}>
                                <FontAwesomeIcon
                                    icon={faInfoCircle}
                                    size="sm"
                                    className="fa-fw me-2"
                                />
                                {text}
                            </Dropdown.Item>
                        )

                    case 'button':
                        return (
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={handleShow}
                            >
                                <FontAwesomeIcon icon={faInfoCircle} />
                            </Button>
                        )
                    default:
                        return (
                            <span onClick={handleShow}>
                                <FontAwesomeIcon
                                    icon={faInfoCircle}
                                    size="sm"
                                    className="fa-fw me-2"
                                />
                                {text}
                            </span>
                        )
                }
            })()}

            <Dialog
                visible={show}
                modal
                header={headerElement}
                footer={footerContent}
                style={{ width: '40rem' }}
                position="top"
                onHide={() => {
                    if (!show) return
                    setShow(false)
                }}
            >
                <div className="m-0 pt-5 text-center">
                    <a href="https://samirify.com" target="_blank" rel="noopener noreferrer">
                        <img
                            src={fullLogoLight}
                            alt="Full Logo"
                            className="full-logo mb-4"
                        />
                    </a>

                    <h4>Headless CMS</h4>
                    <small className="text-muted">
                        Version {process.env.REACT_APP_CLIENT_VERSION}
                    </small>
                    <br />
                    <small className="text-muted">
                        Developed by{' '}
                        <a href="https://samirify.com" target="_blank" rel="noopener noreferrer">
                            Samirify LTD
                        </a>
                    </small>
                </div>
            </Dialog>
        </>
    )
}

export default About
